<template lang="html">
  <div class="card dashboard">
    <header class="card-header">
      <p class="card-header-title">
        <router-link to="/tags" class="has-text-dark">
          <span class="icon is-medium">
            <icon 
              icon="book" 
              size="m" />
          </span>
          <span class="has-text-weight-light is-size-4 ml-2">Thema's</span>
        </router-link>
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-gapless" v-if="tagCount >= 1">
        <div class="column has-text-centered">
          <router-link to="/tags">
            <span class="tag is-rounded is-medium" :style="badgeStyle">{{ tagCount }}</span>
          </router-link>
        </div>
      </div>
      <article class="message is-info" v-if="tagCount === 0">
        <div class="message-body">
          Er zijn geen relevante thema's voor jou
        </div>
      </article>
    </div>
    <footer class="card-footer">
      <router-link to="/tags" class="card-footer-item">Thema's</router-link>
    </footer>
  </div>
</template>

<script>

import icon from '../../common/icon'

export default {
  name: 'tags',
  data: function () {
    return {
      tagCount: 0
    }
  },
  methods: {
    getTagsPersonal: function () {
      this.$bus.$emit('loadingEvent', true)
      this.$api.get('tags/personal').then((response) => {
        this.tagCount = response.data.data.length

        this.$bus.$emit('loadingEvent', false)
        this.disabled = false
      }, (error) => {
        this.$bus.$emit('loadingEvent', false)
        this.disabled = false
        this.$bus.$emit('apiErrorEvent', error)
      })
    }
  },
  mounted: function () {
    this.getTagsPersonal()
  },
  computed: {
    badgeStyle: function () {
      return { 
        'background-color': this.$root.$data.theme.buttonColor,
        'color': 'white'
      }
    }
  },
  components: {
    'icon': icon
  }
}
</script>
